<template>
  <v-card
    class="mx-auto"
    max-width="500"
    flat
    v-if="user"
  >
    <v-img
      v-if="user && !user.avatar"
      class="white--text align-end"
      height="300px"
      src="@/assets/noimage.png"
    >
    </v-img>
    <v-img
      v-if="user && user.avatar"
      class="white--text align-end"
      height="200px"
      :src="user.avatar.link"
    >
    </v-img>
    <v-card-title class="mb-8">{{user.name}}</v-card-title>
    <v-card-subtitle>
      {{$t('role')}} : {{user.role.name}}
    </v-card-subtitle>
    <v-card-subtitle>
      {{$t('username')}} : {{user.username}}
    </v-card-subtitle>
    <v-card-subtitle>
      {{$t('password')}} : **********
      <v-btn
        icon
        small
        disabled
      >
        <v-icon color="primary">mdi-pencil</v-icon>
      </v-btn>
    </v-card-subtitle>
    <v-card-subtitle>
      {{$t('mobile')}} : {{user.mobile}}
    </v-card-subtitle>
    <v-card-subtitle>
      {{$t('email')}} : {{user.email}}
    </v-card-subtitle>

    <v-card-text class="text--primary">
    </v-card-text>

    <v-card-actions>
    </v-card-actions>
  </v-card>
</template>

<script>
// import aicomplete from '../../components/general/AIcomplete/index'
  import General from '../../../../Mixins/general'
  export default {
    name: 'Product',
    components: {
    },
    mixins: [General],
    props: ['formType'],
    data: () => ({
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
      render: false,
      isLoading: false,
      alert: false,
      tag: null,
      content: null,
      valid: null,
      message: null,
      alertType: null,
      name: null,
      type: null,
      user: null,
      id: null,
      status: 'active',
      group: null,
      loading: false,
    }),
    watch: {
    },
    beforeMount () {
    },
    mounted () {
      // this.getProfile()
    },
    methods: {
      getProfile () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'getdetail', {
          params: {
            select: 'getProfile',
            id: app.$store.state.userId,
          },
        })
          .then(res => {
            res = res.data
            app.user = res
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped>

</style>
